import React from 'react';
import {
  Row,
  Col,
  Typography,
  Result,
  Button
} from 'antd';
import propTypes from 'prop-types';
const { Text } = Typography;

const NotFound = () => {
  return (
        // @ts-ignore
        <Result
            title={<Typography.Title>Error 404</Typography.Title>}
            icon={<img src="https://genoma-assets.s3.us-east-2.amazonaws.com/genomin.png" />}
            subTitle={<Typography.Paragraph>Lo sentimos, la página que buscas no existe.</Typography.Paragraph>}
            extra={<Button type="primary" style={{display:'none'}}>Next</Button>}
        />
        
  );
}



export default NotFound;